import { render, staticRenderFns } from "./TableDma.vue?vue&type=template&id=dec8048c&"
import script from "./TableDma.vue?vue&type=script&lang=js&"
export * from "./TableDma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports